module.exports = __webpack_public_path__ + "static/media/delete-custom-field.ea7406f9.svg";